/**
 * Roles that see a not public document or a note besides super admins (bitmask, same values on the server).
 * Public scope of documents (public, public NDA required) is a separate field (visibility).
 */
export class VisibleTo {
    public static readonly None = 0;
    public static readonly Client = 1;
    public static readonly Attorney = 2;

    public static includes(value:number|undefined|null, bit:number):boolean{
        return ((value ?? 0) & bit) != 0;
    }

    /** sets or clears one role bit, other bits stay as they are */
    public static set(value:number|undefined|null, bit:number, on:boolean):number{
        const v = value ?? 0;
        return on ? (v | bit) : (v & ~bit);
    }
}
